const cycleNameCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export type CycleSortable = {
  id?: number | string | null;
  name?: string | null;
  startDate?: string | Date | null;
  endDate?: string | Date | null;
  start_date?: string | Date | null;
  end_date?: string | Date | null;
};

function getCycleTime(value: unknown): number | null {
  if (!value) return null;
  const time = new Date(String(value)).getTime();
  return Number.isNaN(time) ? null : time;
}

/** Newest booking cycle first: start date, then end date, then name, then id. */
export function compareCyclesNewestFirst(a: CycleSortable, b: CycleSortable): number {
  const aStart = getCycleTime(a?.start_date ?? a?.startDate);
  const bStart = getCycleTime(b?.start_date ?? b?.startDate);
  if (aStart !== bStart) return (bStart ?? -Infinity) - (aStart ?? -Infinity);

  const aEnd = getCycleTime(a?.end_date ?? a?.endDate);
  const bEnd = getCycleTime(b?.end_date ?? b?.endDate);
  if (aEnd !== bEnd) return (bEnd ?? -Infinity) - (aEnd ?? -Infinity);

  const nameCompare = cycleNameCollator.compare(String(b?.name ?? ''), String(a?.name ?? ''));
  if (nameCompare !== 0) return nameCompare;

  return Number(b?.id ?? 0) - Number(a?.id ?? 0);
}
